// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"55be867c","320":"66cc6f70","453":"5c3315bc","905":"dbb8abdb"}[chunkId] + ".chunk.js";
};